import React from 'react';
import { BundleLanding } from '../components/Product/BundleLanding';

const TriplePackPage: React.FC = () => (
  <BundleLanding
    bundleId="triple-threat"
    seoTitle="Triple Pack — Three-Tub Hydration & Vitamin Recovery"
    seoDescription="The Triple Pack from RaveRemedy: three tubs of premium hydration and vitamin recovery blend, one of each flavour. Free shipping Australia-wide."
    canonical="https://raveremedy.com/triple-pack"
    heroTagline="Three tubs, one of each flavour — the full bundle. Free shipping Australia-wide."
  />
);

export default TriplePackPage;
